import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementStaff } from "./AgreementStaff";
import type { CatalogDTOBase } from "./CatalogDTOBase";
import type { CatalogDiscountStaff } from "./CatalogDiscountStaff";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { CatalogTaxStaff } from "./CatalogTaxStaff";
import type { ProductStaff } from "./ProductStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogStaff implements CatalogDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly catalogName: string | null, public readonly startActive: Date | null, public readonly endActive: Date | null, public readonly items: Array<CatalogItemStaff> | null, public readonly products: Array<ProductStaff> | null, public readonly agreements: Array<AgreementStaff> | null, public readonly taxes: Array<CatalogTaxStaff> | null, public readonly discounts: Array<CatalogDiscountStaff> | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.itemsLoaded = this.items != null;
    this.itemsCached = this.items;
    this.productsLoaded = this.products != null;
    this.productsCached = this.products;
    this.agreementsLoaded = this.agreements != null;
    this.agreementsCached = this.agreements;
    this.taxesLoaded = this.taxes != null;
    this.taxesCached = this.taxes;
    this.discountsLoaded = this.discounts != null;
    this.discountsCached = this.discounts;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemsLoaded: boolean;
  private itemsCached: Array<CatalogItemStaff> | null;
  private productsLoaded: boolean;
  private productsCached: Array<ProductStaff> | null;
  private agreementsLoaded: boolean;
  private agreementsCached: Array<AgreementStaff> | null;
  private taxesLoaded: boolean;
  private taxesCached: Array<CatalogTaxStaff> | null;
  private discountsLoaded: boolean;
  private discountsCached: Array<CatalogDiscountStaff> | null;
  async itemsLazy(): Promise<Array<CatalogItemStaff>> {
    if (!this.itemsLoaded) {
      this.itemsCached = await this.cbiServiceContext!.catalogService().getCatalogStaffItems(this.assignId);
      this.itemsLoaded = true;
    }
    return this.itemsCached!;
  }
  async productsLazy(): Promise<Array<ProductStaff>> {
    if (!this.productsLoaded) {
      this.productsCached = await this.cbiServiceContext!.catalogService().getCatalogStaffProducts(this.assignId);
      this.productsLoaded = true;
    }
    return this.productsCached!;
  }
  async agreementsLazy(): Promise<Array<AgreementStaff>> {
    if (!this.agreementsLoaded) {
      this.agreementsCached = await this.cbiServiceContext!.catalogService().getCatalogStaffAgreements(this.assignId);
      this.agreementsLoaded = true;
    }
    return this.agreementsCached!;
  }
  async taxesLazy(): Promise<Array<CatalogTaxStaff>> {
    if (!this.taxesLoaded) {
      this.taxesCached = await this.cbiServiceContext!.catalogService().getCatalogStaffTaxes(this.assignId);
      this.taxesLoaded = true;
    }
    return this.taxesCached!;
  }
  async discountsLazy(): Promise<Array<CatalogDiscountStaff>> {
    if (!this.discountsLoaded) {
      this.discountsCached = await this.cbiServiceContext!.catalogService().getCatalogStaffDiscounts(this.assignId);
      this.discountsLoaded = true;
    }
    return this.discountsCached!;
  }
}
